/**
 * Product Gallery Zoom Modal
 */
import Flickity from 'flickity';
import productGalleryZoomCarousel from './product-gallery-zoom-carousel';

function productGalleryZoomModal(opts) {
  const config = {
    dom: {
      modalId: 'productGalleryZoomModal',
      modalTrigger: 'js-product-gallery-zoom-modal-trigger',
      gallery: 'js-product-gallery',
      gallery_cell: '.js-product-gallery-carousel-cell',
      carousel: 'js-product-gallery-carousel',
      post_artwork: 'js-post-artwork-image',
      post_artwork_zoom: 'js-post-artwork-zoom',
      zoomCarousel: 'js-product-gallery-zoom-carousel',
      zoomCell: 'js-product-gallery-zoom-carousel-cell',
      videoBtn: '.js-video-control',
    },
    cls: {
      initialSelect: 'is-initial-select',
      active: 'is-active',
    },
  };

  const c = __.extend(config, opts);

  /**
   * Init
   */
  function init() {
    const $galleries = [...document.querySelectorAll(`.${c.dom.gallery}`)];

    if ($galleries && $galleries.length > 0) {
      $galleries?.forEach(($gallery) => {
        if (__.hasClass($gallery, c.cls.active)) return;
        __.addClass($gallery, c.cls.active);
        const { variantId } = $gallery.dataset;
        const modalId = `${c.dom.modalId}${variantId}`;
        const modalConfig = {
          dom: {
            modal_id: modalId,
            trigger: false,
          },
          cb: {
            before_open: () => makeCarousel(modalId),
            after_open: () => modalAfterOpen(modalId),
          },
        };

        const galleryZoomModal = SDG.Modal.init(modalConfig);
        galleryZoomModal?.init();

        addEvents($gallery, galleryZoomModal, modalId);
      });
    }
  }

  function addEvents($gallery, galleryZoomModal, modalId) {
    const $modalTriggers = [...$gallery.querySelectorAll(`.${c.dom.modalTrigger}`)];
    const $firstTrigger = $modalTriggers[0] || null;
    const $modal = document.getElementById(modalId) || null;
    const $flickityCarousel = $modal?.querySelector(`.${c.dom.zoomCarousel}`) || null;

    $modalTriggers?.forEach(($modalTrigger) => {
      $modalTrigger.addEventListener('click', () => {
        const { cellIndex } = $modalTrigger.dataset;

        const $zoomCarousel = document.getElementById(modalId);
        if ($zoomCarousel) {
          const $initialSelect = $zoomCarousel.querySelector(`.${c.dom.zoomCell}.${c.cls.initialSelect}`);
          if ($initialSelect) {
            __.removeClass($initialSelect, c.cls.initialSelect);
          }
          const $newInitialSelect = $zoomCarousel.querySelector(`.${c.dom.zoomCell}[data-cell-index="${cellIndex}"]`);

          if ($newInitialSelect) {
            __.addClass($newInitialSelect, c.cls.initialSelect);
          }

          if ($firstTrigger) {
            const { cellIndex: firstCellIndex } = $firstTrigger.dataset || null;
            const $cells = $flickityCarousel?.querySelectorAll(`.${c.dom.zoomCell}`) || [];

            if (firstCellIndex) {
              syncCellIndex(firstCellIndex, $cells);
            }
          }

          if ($flickityCarousel && cellIndex) {
            const activeCarousel = Flickity.data($flickityCarousel) || null;
            const $selectedCell = $flickityCarousel.querySelector(`.${c.dom.zoomCell}[data-cell-index="${cellIndex}"]`) || null;

            if ($selectedCell && activeCarousel) {
              activeCarousel?.selectCell($selectedCell, false, true);
            }
          }
        }

        openModal(galleryZoomModal, modalId);
      });
    });
  }

  /**
   * Sync Cell Index
   * @description On init we need to sync the cell index encase postartwork wrappers are removed
   * @param {Number} startingIndex
   * @param {NodeList} cells
   * @returns {void}
   */
  function syncCellIndex(startingIndex, cells) {
    if (!startingIndex || !cells?.length > 0) return;
    let cellIndex = Number(startingIndex);

    [...cells].forEach(($cell) => {
      if ($cell?.childElementCount > 0) {
        $cell.setAttribute('data-cell-index', cellIndex);
        cellIndex += 1;
      }
    });
  }

  /**
   * Make carousel
   */
  function makeCarousel(modalId) {
    const $postArtworks = document.querySelectorAll(`.${c.dom.post_artwork}`) || [];

    if ($postArtworks?.length > 0) {
      [...$postArtworks].forEach(($postArtwork) => {
        const $firstSlide = $postArtwork.querySelector(`.${c.dom.post_artwork_zoom}`);
        const $carousel = document.querySelector(`#${modalId} .${c.dom.zoomCarousel}`);
        const flickityCarousel = Flickity.data($carousel);
        flickityCarousel?.destroy();
        const hasCurrentSpec = window.localStorage.getItem('currentFrameSpec') || false;

        if (!hasCurrentSpec && $firstSlide) {
          // if there is no current spec, remove the cell
          $firstSlide?.remove();
        } else if ($postArtwork && $firstSlide) {
          const $clone = $postArtwork.cloneNode(true);

          // clone post artwork element to the first slide
          $firstSlide.appendChild($clone);
        }

        productGalleryZoomCarousel({
          dom: {
            carousel: `#${modalId} .${c.dom.zoomCarousel}`,
            videoBtn: c.dom.videoBtn,
          },
        });
      });
    }

    if (!$postArtworks?.length > 0) {
      const $modal = document.getElementById(modalId);
      const $artworkWrapper = $modal?.querySelector(`.${c.dom.post_artwork_zoom}`) || null;

      if ($artworkWrapper) {
        $artworkWrapper.remove();
      }

      productGalleryZoomCarousel({
        dom: {
          carousel: `#${modalId} .${c.dom.zoomCarousel}`,
          videoBtn: c.dom.videoBtn,
        },
      });
    }
  }

  /**
   * Modal after open
   */
  function modalAfterOpen(modalId) {
    const $carousel = document.querySelector(`#${modalId} .${c.dom.zoomCarousel}`);
    const flickityCarousel = Flickity.data($carousel);
    flickityCarousel?.resize();
  }

  /**
   * Open modal
   */
  function openModal(galleryZoomModal, modalId) {
    galleryZoomModal?.open(modalId);
  }

  return init();
}

export default productGalleryZoomModal;
